enum PublicSetting {
	MAX_2FA_RETRY_COUNT = 'Max.Twofa.Retry.Count',
	REFERRALS_CODELIMIT = 'SpectroCoin.Referrals.CodeLimit',
}

export default PublicSetting;
